import api from '@/client/core/api'
import { TCampaign } from '@/typings/api/campaigns.type'

/**
 * キャンペーン情報を取得する
 */
export async function getCampaign(campaignId: number): Promise<TCampaign> {
  const result = await api.get(`/campaigns/${campaignId}`)

  return result.data as TCampaign
}
